import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { remove } from "lodash";
export const useMultipleSelect = () => {
  const handleSelectMultipleChange = (selectedValue, type, currentValue, multiple) => {
    switch (type) {
      case "unselect":
        {
          return multiple && Array.isArray(currentValue) ? remove(currentValue, a => a !== selectedValue.id) : "";
        }
      case "select":
        {
          if (multiple) {
            if (selectedValue.id === "all") return "all";
            if (_includesInstanceProperty(currentValue).call(currentValue, "all")) {
              $(".select2-results__option").first().attr("aria-selected", "false");
              return [selectedValue.id];
            }
            return [...currentValue, selectedValue.id];
          }
          return selectedValue.id;
        }
    }
  };
  const handleVSelectMultipleChange = (selectedValue, type, currentValue, multiple) => {
    switch (type) {
      case "unselect":
        {
          return multiple && Array.isArray(currentValue) && selectedValue ? remove(currentValue, a => a !== selectedValue.id) : "";
        }
      case "select":
        {
          if (multiple) {
            if (selectedValue.fullName === "All") return "all";
            if (_includesInstanceProperty(currentValue).call(currentValue, "all")) {
              return [selectedValue.id];
            }
            return [...currentValue, selectedValue.id];
          }
          return selectedValue.id;
        }
    }
  };
  return {
    handleSelectMultipleChange,
    handleVSelectMultipleChange
  };
};